<script setup lang="ts">
import useMaskStore from '@shop/store/mask';

const mask = useMaskStore();

const closeMask = () => {
  mask.close();
};
</script>

<template>
  <div v-if="mask.visible" class="mask__container" @click="closeMask" @mouseover="closeMask"></div>
</template>

<style lang="scss" scoped>
.mask {
  &__container {
    position: fixed;
    z-index: 800;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
}
</style>
